import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, inject, Input, Output, signal, ViewChild } from '@angular/core';
import { AddVideoComponent } from '../../../../atoms/add-video/add-video.component';
import { FormsModule } from '@angular/forms';
import { BriefApplicationResponseDto, VideoFormatEnum } from '../../../../common/general-types/briefs.dto';
import { CreateVideoDto, VideoResponseDto, VideoStatusEnum } from '../../../../common/general-types/videos.dto';
import { VideoService } from '../../../../services/video/video.service';

@Component({
  selector: 'vs-upload-draft',
  standalone: true,
  imports: [AddVideoComponent, FormsModule],
  templateUrl: './upload-draft.component.html',
  styleUrl: './upload-draft.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UploadDraftComponent {

  @ViewChild('uploadDraftDialog', { static: false }) uploadDraftDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('uploadDraftButton', { static: false }) uploadDraftButton?: ElementRef<HTMLButtonElement>;

  @Input() briefId!: string;
  @Input() creatorId!: string;
  @Input() briefApplicationId!: string;
  @Input() focussedApplication: BriefApplicationResponseDto | undefined = undefined;
  @Output() close = new EventEmitter<void>();
  @Output() videoUploaded = new EventEmitter<VideoResponseDto>();  

  draftTitle = signal<string>('My Draft');
  uploadVideo = signal<{ file: string, fileKey: string, fullUrl: string, videoId: string } | undefined>(undefined);
  savingVideo = signal<boolean>(false);

  /** Services */
  private videoService = inject(VideoService);
  /** Services - END */

  onVideoUploaded(event: any) {
    console.log('onVideoUploaded: ', event);
    this.uploadVideo.set({
      file: event.file,
      fileKey: event.fileKey,
      fullUrl: event.fullUrl,
      videoId: event.videoId,
    });
  }

  saveDraft() {
    console.log('saveDraft(): ', this.uploadVideo());
    console.log('draftTitle: ', this.draftTitle());
    console.log('briefId: ', this.briefId);

    this.savingVideo.set(true);

    const updateInitialVideo: Partial<CreateVideoDto> = {
      creatorId: this.creatorId,
      videoName: this.draftTitle(),
      key: this.uploadVideo()?.fileKey || '',
      videoFormat: VideoFormatEnum.Vertical,
      status: VideoStatusEnum.New,
      briefId: this.briefId,
      briefApplicationId: this.briefApplicationId,
    }

    console.log('newVideo: ', updateInitialVideo);

    this.videoService.update(this.uploadVideo()!.videoId, updateInitialVideo).subscribe({
      next: (response: VideoResponseDto) => {
        console.log('response: ', response);
        this.savingVideo.set(false);
        this.videoUploaded.emit(response);
        this.closeDrawer();
      },
      error: (error: any) => {
        console.error('error: ', error);
        this.savingVideo.set(false);
      }
    });
  }

  closeDrawer() {
    this.uploadDraftDialog?.nativeElement.close();
    this.close.emit();
  }
}
